let defaultState = {
    productsList: [],
    onSaleProductList: [],
    brandsProduct:[],
    usersList: [],
    popularDressesList:[],
    importedproductList:[],
    ordersList: [],
    categories: [],
    subcategories: [],
    accessToken:null,
    allPoints:[],
    userInfo:[],
    userAccount:[],
    userExist:false,
    loginStatus:true,
    loggedInUserAccount:[],
    loginRequestStatus:true,
    events:[],
    username:[],
    product: [],
    savedItem:[],
    products:[],
    analytics:{},
    addingProduct:false,
    earnings:[],
    JigarKey:"",
    jigarLoader:true,
    JigarProduct: [],
    cat:{ "Color": ["red"],
             "BrandName":[],
              "Fabric":[],
              "Design":[] }
    
}

const mainReducer = (state = {loaded: false}, action) => {
    switch (action.type) {

        case "LOAD_PRODUCTS":
            return {
                ...state,
                productsList: [...action.productsList]
            }
            case "JIGAR_PRODUCT":
                return {
                    ...state,
                    JigarProduct: [...action.JigarProduct],
                    jigarLoader: false
                }
                case "JIGAR_KEY":
                    return {
                        ...state,
                        JigarKey: [action.JigarKey]
                    }
            case "LOAD_BRANDS":
            return {
                ...state,
                brandsProduct: [...action.brandsProduct]
            }
            case "LOAD_IMPORTED":
            return {
                ...state,
                importedproductList: [...action.importedproductList]
            }
            case "LOAD_ONSALE":
            return {
                ...state,
                onSaleProductList: [...action.onSaleProductList]
            }
            case "LOAD_POPULAR":
            return {
                ...state,
                popularDressesList: [...action.popularDressesList]
            }
            case "LOAD_SAVEDPRODUCTS":
            return {
                ...state,
                savedItem: [...action.savedItem]
            }
            

        case "ADDING_PRODUCT":
        return {
            ...state,
            addingProduct:true
        }
        case "USERNAME_SUCCESS":
        return {
            ...state,
            username:[...action.username]
        }

        case "ADD_PRODUCT":
            return {
                ...state,
                addingProduct:false
            }

        case "LOAD_USERS":
            return {
                ...state,
                usersList: [...action.usersList]
            }

        case "CREATE_ORDER":
            return {
                ...state,
                ordersList: true
            }

        case "GET_CATEGORIES":
            return {
                ...state,
                categories: action.categories
            }
            case "GET_SINGLE_PRODUCT":
                    return {
                        ...state,
                        product: action.product
                    }

        case "ADD_CATEGORY":
            return {
                ...state
            }
            case "Cat_Change":
                return{
                    ...state,
                    cat: action.cat
                }

        case "GET_SUBCATEGORIES":
            return {
                ...state,
                subcategories: action.subcategories
            }

        case "LOGIN_REQUEST":
        return{
            ...state,
            loginRequestStatus:false
        }

        case "LOGIN_SUCCESS":

        return{
            ...state,
            userExist:true,
            loggedInUserAccount:action.userInfo,
            userInfo:action.userInfo,
            loginRequestStatus:true,
            loginStatus:true
        }

        case "LOGIN_FAILED":
        return{
            ...state,
            loginRequestStatus:true,
            loginStatus:false
        }

        case "LOGOUT":
        return{
            ...state,
            loginStatus:false,
            loggedInUserAccount:[]
        }
    

        case "GET_POINTS_HISTORY":
        return{
            ...state,
            allPoints:action.points
        }

        case "GET_ACCOUNT_DETAILS":
        return{
            ...state,
            userAccount:action.account
        }

        case "UPDATE_POINTS":
        return {
            ...state,
            userAccount:action.account
        }

        case "SEND_POINTS":
        return{
            ...state,
            usersList:action.users
        }

        case "GET_EVENTS":
        return{
            ...state,
            events:action.events
        }

        case "GET_ANALYTICS":
        return{
            ...state,
            analytics:action.analytics
        }

        case "GET_DAILY_EARNINGS":
        return{
            ...state,
            earnings:action.earnings
        }

        default:
            return {
                ...state
            }
    }
}


export default mainReducer;